import { useQuery } from '@apollo/client'
import { Box, List, type MediumIcon, Row, Title } from '@factorialco/deprecated-design-system'
import { SettingCyclesDocument } from 'generated/resources/graphql'

import Loading from 'modules/core/components/Loading'
import i18n from 'modules/core/lib/i18n'

export interface ModuleConfig {
  key: string
  titleKey: string
  illustration: MediumIcon
  navigationPath: string
}

const Cycles = () => {
  const { data, loading, error } = useQuery(SettingCyclesDocument)
  const cycles = data?.compensations.cyclesConnection.nodes || []

  if (loading) {
    return <Loading />
  }

  if (error) {
    throw new Error('Error fetching data')
  }

  return (
    <Box flexDirection="row" alignItems="center" paddingX="s64" paddingY="s32" width="full">
      <Row>
        <Row.Col halfWidth>
          <Box paddingRight="s64">
            <Title
              variant="500"
              title={i18n.t('compensations.settings.cycles.title')}
              description={i18n.t('compensations.settings.cycles.description')}
              illustration={'calendar-clock'}
            />
          </Box>
        </Row.Col>
        <Row.Col halfWidth>
          <Box
            component="ul"
            borderRadius={{ all: 'abs016' }}
            background="grey000White"
            border={{
              all: {
                width: 's1',
                color: 'grey400',
                style: 'solid',
              },
            }}
          >
            {cycles.map((cycle) => (
              <List.Item key={cycle.country}>
                <List.Title>{cycle.countryLabel}</List.Title>
                <List.Description>{cycle.legalEntitiesLabel}</List.Description>
              </List.Item>
            ))}
          </Box>
        </Row.Col>
      </Row>
    </Box>
  )
}

export default Cycles
